function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  x1: 178.87869,
  x2: 235.54539,
  y1: 295.9104,
  y2: 219.2437,
  gradientTransform: "translate(-164.4 -208.05)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop4",
  offset: 0,
  stopColor: "#3480bd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop6",
  offset: 1,
  stopColor: "#7eb8ed"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "path9",
  fill: "url(#SVGID_1_)",
  d: "M86.8 67.95v-38.6c0-3.6-1.9-6.9-5-8.7L48.4 1.35c-3.1-1.8-6.9-1.8-10 0L5 20.65c-3.1 1.8-5 5.1-5 8.7v38.6c0 3.6 1.9 6.9 5 8.7l33.4 19.3c3.1 1.8 6.9 1.8 10 0l33.4-19.3c3.1-1.8 5-5.1 5-8.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path15",
  fill: "#fff",
  d: "M41.8 54.05l-28.5-16.1c-2.3-1.3-2.3-4.6 0-5.9l28.5-16.1c1-.6 2.3-.6 3.4 0l28.4 16c2.3 1.3 2.3 4.6 0 5.9l-28.5 16.1c-1 .7-2.3.7-3.3.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path17",
  fill: "#fff",
  d: "M67.5 52.35l-9.7-5.5-12.7 7.2c-1 .6-2.3.6-3.4 0L29 46.85l-9.7 5.5c-1.8 1-1.8 3.7 0 4.8l22.8 12.9c.8.5 1.9.5 2.7 0l22.8-12.9c1.8-1.1 1.8-3.8-.1-4.8z",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path19",
  fill: "#fff",
  d: "M61.5 68.65l-7.2-4.1-9.5 5.4c-.8.5-1.9.5-2.7 0l-9.5-5.4-7.2 4.1c-1.4.8-1.4 2.8 0 3.6l17.1 9.7c.6.4 1.4.4 2 0l17.1-9.7c1.3-.8 1.3-2.8-.1-3.6z",
  opacity: 0.4
});

var SvgMinLogo = function SvgMinLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "min-logo",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "0 0 86.800003 97.300003",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/min-logo.dde3fc6c.svg";
export { ForwardRef as ReactComponent };